/**
 * Firebase instance registry for @coparent/shared.
 *
 * Each platform (web, mobile) initializes Firebase with its own config and
 * persistence adapter, then calls initializeFirebase() to make the instances
 * available to all shared services.
 *
 * Usage (in app startup):
 *   import { initializeFirebase } from '@coparent/shared/src/firebase';
 *   initializeFirebase({ db, auth, storage });
 */

const _state = { db: null, auth: null, storage: null };

export function initializeFirebase({ db, auth, storage }) {
  _state.db = db;
  _state.auth = auth;
  _state.storage = storage;
}

export function getDb() {
  if (!_state.db) throw new Error('@coparent/shared: Firebase not initialized. Call initializeFirebase() first.');
  return _state.db;
}

export function getAuth() {
  if (!_state.auth) throw new Error('@coparent/shared: Firebase not initialized. Call initializeFirebase() first.');
  return _state.auth;
}

export function getStorage() {
  if (!_state.storage) throw new Error('@coparent/shared: Firebase not initialized. Call initializeFirebase() first.');
  return _state.storage;
}
